const bundleVariantInput = document.querySelectorAll('.product-section .variant-input-wrap-bundle .variant-input');
const bundleVariantInputLabelFirst = bundleVariantInput[0].querySelector('label').click();

function updateMainProductVariant(){

    setTimeout(function() {

        const bundleElementsTop = document.querySelector('.product-section .bundle-elements.bundle-elements__top');
        const bundleSizesItems = bundleElementsTop.querySelectorAll('.size-options .variant-input');
        const bundleColorsContainerItem = bundleElementsTop.querySelectorAll('.color-options .block-size');

        /* VARIANTS */

        function updateSizeColor(size){

            for(let i=0;i<bundleColorsContainerItem.length;i++){
                if(bundleColorsContainerItem[i].dataset.size == size){
                    bundleColorsContainerItem[i].setAttribute('enabled', '');
                    const colorsItems = bundleColorsContainerItem[i].querySelectorAll('.variant-input');
                    if(colorsItems[0] != undefined){
                        const firstColorLabel = colorsItems[0].querySelector('label');
                        firstColorLabel.click();
                    }
                }else{
                    bundleColorsContainerItem[i].removeAttribute('enabled');
                }
            }
            
        }
        updateSizeColor(bundleColorsContainerItem[0].dataset.size);

        bundleSizesItems.forEach(option => {
            option.addEventListener('click', () => {
                if(!option.hasAttribute('disabled')){
                    const input = option.querySelector('input');
                    updateSizeColor(input.value);
                }
            })
        })

        for(let i=0;i<bundleSizesItems.length;i++){
            if(!bundleSizesItems[i].hasAttribute('disabled')){
                const label = bundleSizesItems[i].querySelector('label');
                label.click();
                break;
            }
        }

    }, 100)


}
updateMainProductVariant();

/* BUNDLE */

const productColorSizeAvailability = document.querySelector('.product-color-size-availability');
const productColorSizeAvailabilitySizes = productColorSizeAvailability.querySelectorAll('.size-block');

bundleVariantInput.forEach(mainBundle => {
    mainBundle.addEventListener('click', () => {

        if(mainBundle.classList.contains('variant-with-reco-1')){
            updateMainProductVariant();
        }

        const mainBundleInput = mainBundle.querySelector('input');
        const bundleWrapperContainer = document.querySelector(`.product-section .bundle-elements__bottom.${mainBundleInput.dataset.elementsToShow}`);

        if(bundleWrapperContainer != null){
          
          setTimeout(function() {
  
              const bundleWrapper = bundleWrapperContainer.querySelectorAll('.bundle-wrapper');
  
              bundleWrapper.forEach(item => {
                  
                  const sizeSelect = item.querySelector('.bundle__select--tailles');
                  const colorSelect = item.querySelector('.bundle__select--couleurs');
                  const colorImagesContainer = item.querySelector('.bundle-thumbnail');
  
                  function updateInputBundleColorImage(size, color){
                      const colorImages = colorImagesContainer.querySelectorAll('img');
                      for(let k=0;k<colorImages.length;k++){
                          if(colorImages[k].dataset.color == color){
                              colorImages[k].style.display = 'block';
                          }else{
                              colorImages[k].style.display = 'none';
                          }
                      }
                  }
  
                  function updateInputBundleColor(size){
  
                      colorSelect.innerHTML = '';
  
                      // COLOR
                      for(let i=0; i<productColorSizeAvailabilitySizes.length;i++){
  
                          if(productColorSizeAvailabilitySizes[i].dataset.size == size){
  
                              const sizeColors = productColorSizeAvailabilitySizes[i].querySelectorAll('input');
  
                              if(sizeColors.length > 0){
  
                                  for(let y=0;y<sizeColors.length;y++){
                                      const newColor = document.createElement('option');
                                      newColor.value = sizeColors[y].value;
                                      newColor.textContent = sizeColors[y].value;
                                      colorSelect.appendChild(newColor);
      
                                      // AJUST IMAGE COLOR
                                      if(y==0){
                                          updateInputBundleColorImage(sizeSelect.value, sizeColors[y].value)
                                      }
                                  }
                              }else {
                                  /*
                                  const newInput = document.createElement('option');
                                  newInput.value = 'Stock épuisé';
                                  newInput.textContent = 'Stock épuisé';
                                  newInput.setAttribute('disabled', '');
                                  colorSelect.appendChild(newInput);
                                  colorSelect.value = 'Stock épuisé';
                                  */
                              }
  
  
                          }
                      }
  
                  }
  
                  // FIRST SIZE
                  for(let i=0;i<sizeSelect.length;i++){
                      if(!sizeSelect[i].hasAttribute('disabled')){
                          const size = sizeSelect[i].textContent.replace(/\s+/g, '');
                          updateInputBundleColor(size);
                          break;
                      }
                  }
  
                  // EVENTS
                  sizeSelect.addEventListener('change', () => {
                      updateInputBundleColor(sizeSelect.value);
                  })
  
                  // COLOR IMAGES
                  colorSelect.addEventListener('change', () => {
                      updateInputBundleColorImage(sizeSelect.value, colorSelect.value)
                  })
  
              })
  
          }, 100)

        }

    })
})